import Hotjar from '@hotjar/browser';
import { createApp } from 'vue';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import { i18n } from './i18n';
import router from './router';
import store from './store';

// Import CSS
import './assets/css/main.css';
import './assets/css/style.css';

// Import Firebase
import './firebase/config';

const app = createApp(App);

if (import.meta.env?.MODE === 'development' || process.env.NODE_ENV === 'development') {
  app.config.devtools = true
}

// Configure Vue Gtag
app.use(VueGtag, {
  config: { id: 'AW-11388837677' },
});


//Add Bitrix24 Live Chat script
(function(w,d,u){
  console.log('[Bitrix] Iniciando carga del script de Bitrix24');
  var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/60000|0);
  var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);

  // Declarar un evento global que se disparará cuando el widget de Bitrix esté listo
  s.onload = function() {
    console.log('[Bitrix] Script de Bitrix cargado correctamente');
    // Esperar un momento para que el iframe se agregue al DOM
    setTimeout(() => {
      // Crear un evento personalizado para notificar que Bitrix se ha cargado
      const bitrixReadyEvent = new CustomEvent('bitrix24-loaded');
      document.dispatchEvent(bitrixReadyEvent);
      console.log('[Bitrix] Evento bitrix24-loaded disparado');
    }, 1000);
  };

  // Añadir un manejador para errores
  s.onerror = function() {
    console.error('[Bitrix] Error al cargar el script de Bitrix24');
  };
})(window,document,'https://cdn.bitrix24.com/b2514537/crm/site_button/loader_18_9j7h8o.js');

// Respaldo: buscar el iframe periódicamente y disparar el evento si se encuentra
setTimeout(() => {
  const checkBitrixInterval = setInterval(() => {
    const widget = document.querySelector('iframe[src*="bitrix"]');
    if (widget) {
      console.log('[Bitrix] Widget detectado por el intervalo de respaldo');
      const bitrixReadyEvent = new CustomEvent('bitrix24-loaded');
      document.dispatchEvent(bitrixReadyEvent);
      clearInterval(checkBitrixInterval);
    }
  }, 1000);

  // Detener después de 20 segundos para no consumir recursos indefinidamente
  setTimeout(() => clearInterval(checkBitrixInterval), 20000);
}, 3000);

// Initialize Hotjar
const siteId = 5002487;
const hotjarVersion = 6;
Hotjar.init(siteId, hotjarVersion);

app.use(i18n);
app.use(store);
app.use(router);
app.mount('#app');
